import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import "./SuccessHandler.sass";
import success_image from "../images/Illustration-success.png";
import { BASE } from "../basedata/constants";

const SuccessHandler = () => {
  const { t } = useTranslation(); 
  const [accepted, setAccepted] = useState(false);

  const [clearFlow, setClearFlow] = useState(false);



  useEffect(() => {
    const _temp_language = sessionStorage.getItem('language') || 'pt'
    const _clearFlow = sessionStorage.getItem('clear_flow')

    sessionStorage.clear()
    sessionStorage.setItem('success_flow', 'true')
    sessionStorage.setItem('language', _temp_language)
    if(_clearFlow && _clearFlow === 'true'){
      setClearFlow(true)
    }
  }, []);


  return (
    <div className="success-container">
      <div className="progress-indicator">
        {Array.from({ length: 6 }).map((_, index) => (
          <div key={index} className="progress-bar"></div>
        ))}
      </div>
      <div className="left-side"></div> 
      <div className="right-side">
      <img className="logo" src={BASE.company.logo} alt={BASE.company.name} />
        <div className="success-card">
          <h1 className="success_title">
            Uhuuu!
          </h1>
          <div className="success-message-container">
            <p className="success-message">
            <strong>{t("success_page.sub_title")}</strong> <br/><br/>
            No dia do evento, basta fazer a leitura da sua biometria facial para embarcar na rede global de identidade e confiança Unico.
            </p>
              {/* <img src={success_image} className="no-svg-tip" alt="Sucesso!" /> */}

         
          </div>
        </div>
      </div>
      {/* <footer className="success-footer">
        <div className="success-footer-logo"></div>
      </footer> */}
    </div>
  );
};

export default SuccessHandler;